<div class="modal-header px-3 py-1">
  <h5 id="modal-basic-title" class="modal-title">Edit Referral Match Verifications</h5>
</div>
<div class="modal-body">
  <form>

    <div class="mt-3">
      <h5>Patient Referrals From EHR Feeds</h5>
      <app-referral-match-verifications-standard-edit
        [capture]="capture"
        [patientPrescriber]="patientPrescriber"
        (referralMatchOptionsChanged)="onReferralMatchOptionsChange($event)" />
    </div>

    <div class="mt-3">
      <h5>Patient Referrals From Client Tasks</h5>
      <app-referral-match-verifications-client-edit
        [capture]="capture"
        [patientPrescriber]="patientPrescriber"
        (clientReferralMatchOptionsChanged)="onClientReferralMatchOptionsChange($event)" />
    </div>

    <div class="mt-3">
      <h5>Referral Evidence Found in EHR</h5>
      <app-referral-match-verifications-ehr-edit
        [capture]="capture"
        [patientPrescriber]="patientPrescriber"
        (ehrReferralMatchOptionsChanged)="onEhrReferralMatchOptionsChange($event)" />
    </div>

    @if (showClientReferralDatesSection) {
      <div class="mt-3">
        <h5>Client Referral Dates</h5>
        <div class="bg-light border px-2">
          <app-referral-match-verifications-client-dates-edit
            [capture]="capture"
            [patientPrescriber]="patientPrescriber" />
        </div>
      </div>
    }

    <div class="mt-3 mb-2">
      <app-referral-match-verifications-notes
        [patientPrescriber]="patientPrescriber"
        (notesChanged)="onNotesChange($event)" />
    </div>
  </form>
  <div>
    <div class="text-end">
      @if (errors) {
        <span class="text-danger pe-2">{{ errors }}</span>
      }
      @if (responseErrors) {
        <span class="text-danger pe-2">{{ responseErrors }}</span>
      }
      <button type="button" class="btn btn-primary" (click)="onSaveClick()" [disabled]="errors">Save</button>
      <button type="button" class="btn btn-secondary" (click)="onCancelClick()">Cancel</button>
    </div>
  </div>
</div>
